// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "staticPC/js/" + chunkId + "." + {"16":"dee8ab17","189":"ab890626","222":"78aee78d","319":"a92ed566","327":"756d048d","336":"fbe16551","454":"3250277e","506":"a1bc0c2e","940":"d95987dd"}[chunkId] + ".js";
};